import { saveAs } from 'file-saver';
import { exportTransactions } from '~/apps/shared/apis/transactions';

export const downloadCsvReport = async (orgId, dtStart, dtEnd) => {
  const blob = await exportTransactions(orgId, dtStart, dtEnd);
  saveAs(blob, 'report.csv');
};
